import React, {useEffect, useState} from 'react';
import {VscFeedback} from "react-icons/vsc";
import {CourseFeedback} from "../CourseFeedback";
import {getAgreementInfo} from "../../services/ProductRepository";
import {useError} from "../../hooks/useError";
import Header from "../navigation/Header";
import {Link, useParams} from "react-router-dom";


export function SubscriptionPanel() {
    const [provideFeedback, setProvideFeedback] = useState(false);
    const [agreement, setAgreement] = useState(null);
    const params = useParams();

    const {setErrorMessage} = useError();

    useEffect(() => {
        getAgreementInfo(setErrorMessage).then(result => setAgreement(result))
    }, []);

    if(agreement == null) {
        return (
            <div>
                <Header/>
                <div className={"container"}>
                    <p>Noe gikk galt :(</p>
                </div>
            </div>
        );
    }

    return (
        <div>
            <CourseFeedback show={provideFeedback} setShow={setProvideFeedback}/>
            <div className={"row w-100"}>

                <div className={"col border bg-white rounded p-3"}>
                    <h5 className={"mb-4 fw-bold"}>Ditt abonnement</h5>
                    <h3>{agreement.name}</h3>
                    <h1>{agreement.pricePerMonth} NOK / måned</h1>
                    <p className={"text-muted"}>Fornyes automatisk {agreement.renewalDate}</p>

                    {
                        agreement.agreementType === "VIPPS" ?
                            <Link to={"administrer"} className={"btn btn-dark text-white"} data-testid={"endre-plan"}>Endre plan</Link>
                            :
                            <div className={"badge bg-danger"}>
                                <h4 className={"p-0 m-0"}>TEST ABONNEMENT</h4>
                            </div>
                    }

                </div>
                <div className={"col-4 border bg-white rounded p-3 ms-2"}>
                    <h5 className={"mb-4 fw-bold"}>Tilbakemelding</h5>
                    <p className={"m-0 p-0"}>Liker du kurset eller ønsker forbedringer?</p>
                    <button className={"btn btn-success m-0"}
                            onClick={() => setProvideFeedback(true)}>
                        <VscFeedback size={16} className={"me-3"}/>
                        Gi tilbakemelding
                    </button>
                </div>
            </div>

        </div>
    );

}